import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    cart: Cart;
    /**
     * If true, the notes will display in a text field for editing.
     * If false, the notes will display as read-only text.
     * Default value: false
     */
    editable?: boolean;
    onNotesChange?: (updatedNotes: string) => void;
    label?: string;
    extendedStyles?: CartUnitsNotesStyles;
}

type Props = OwnProps & HasCartLineContext;

export interface CartUnitsNotesStyles {
    wrapper?: InjectableCss;
    toggleLink?: LinkPresentationProps;
    editableNotesTextArea?: TextFieldPresentationProps;
    readOnlyNotesText?: SmallHeadingAndTextStyles;
}

export const CartUnitsNotesStyles: CartUnitsNotesStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            div[class^="FormFieldStyle"] {
                > div[class^="FormInputWrapper"] {
                    /* Chrome, Safari, Edge, Opera */
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    /* Firefox */
                    input[type="number"] {
                        -moz-appearance: textfield;
                    }
                }
            }
        `,
    },
    toggleLink: {
        css: css`
            margin-bottom: 10px;
        `,
    },
};

const CartUnitsNotes: FC<Props> = ({
    cart,
    cartLine,
    editable = false,
    onNotesChange = () => {},
    label,
    extendedStyles,
}) => {
    const [showUnitNotes, setshowUnitNotes] = useState(true);
    const lineNotesClickHandler = () => {
        setshowUnitNotes(!showUnitNotes);
    };

    const [ProductUnitcost, setProductUnitcost] = useState(cartLine.properties.unitCost);

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setProductUnitcost(event.currentTarget.value);
    };

    // const onKeyDownHandler = (event: React.KeyboardEvent) => {
    //     // eslint-disable-next-line radix
    //     if (!((event.keyCode > 45 && event.keyCode < 58) || event.keyCode === 8 || event.keyCode === 190)) {
    //         event.preventDefault();
    //     }
    // };

    const blurHandler = () => {
        onNotesChange(ProductUnitcost);
    };

    // const heading = showUnitNotes
    //     ? "Unit Cost"
    //     : "Unit Cost";
    useEffect(() => {
        setProductUnitcost(cartLine.properties.unitCost);
    }, [cartLine.properties.unitCost]);

    const [styles] = React.useState(() => mergeToNew(CartUnitsNotesStyles, extendedStyles));

    if (editable) {
        return (
            <StyledWrapper {...styles.wrapper}>
                {/* <Link {...styles.toggleLink} onClick={lineNotesClickHandler} data-test-selector="cartunit_notesShowHideButton">
                    {translate(heading)}
                </Link> */}
                {showUnitNotes && (
                    <TextField
                        {...styles.editableNotesTextArea}
                        value={ProductUnitcost}
                        // label={heading}
                        type="number"
                        disabled={!cart.canModifyOrder}
                        onChange={changeHandler}
                        onBlur={blurHandler}
                        data-test-selector="cartunit_notes"
                    />
                )}
            </StyledWrapper>
        );
    }

    if (!cartLine.properties.unitCost) {
        return null;
    }

    return (
        <SmallHeadingAndText
            {...styles.readOnlyNotesText}
            heading={label || translate("Item Notes")}
            text={cartLine.properties.unitCost}
        />
    );
};

export default withCartLine(CartUnitsNotes);
